import * as linkify from 'linkifyjs'
import {
  isCommentUrl,
  isQuestionUrl,
  getCommentId,
  getQuestionId
} from '@/utils/url'

export type PreviewLinkType = 'answer' | 'question'
export type PreviewLink = {
  type: PreviewLinkType
  link: string
  id: number
}

export const extractPreviewLinks = (content: string): Array<PreviewLink> => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(content, 'text/html')
  const textOnlyContent = doc.body.textContent || ''

  const allLinks = linkify.find(textOnlyContent)
  const urls = allLinks.filter((v) => v.type === 'url').map((v) => v.value)

  const previewLinks: Array<PreviewLink> = []
  for (let i = 0; i < urls.length; i++) {
    const url = urls[i]

    if (isCommentUrl(url)) {
      previewLinks.push({
        type: 'answer',
        link: url,
        id: getCommentId(url)
      })
    } else if (isQuestionUrl(url)) {
      previewLinks.push({
        type: 'question',
        link: url,
        id: getQuestionId(url)
      })
    }
  }
  return previewLinks
}

export interface ContentPreviewUtils {
  extractPreviewLinks: typeof extractPreviewLinks
}
